import { render, staticRenderFns } from "./viewPayrollDetail.vue?vue&type=template&id=6e86bf20&scoped=true&"
import script from "./viewPayrollDetail.vue?vue&type=script&lang=js&"
export * from "./viewPayrollDetail.vue?vue&type=script&lang=js&"
import style0 from "./viewPayrollDetail.vue?vue&type=style&index=0&id=6e86bf20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e86bf20",
  null
  
)

export default component.exports